import "../../styles/style"
import "../../loading/style"
import "../../image/style"
import "../index.scss"
